/**
 * storage — the one localStorage key per product, kept by NAME (plan 2026_09_01_tos_gate.md §8.3).
 * `narcis_tos_accepted` and `ovid_tos_accepted` are the literal keys those products' own
 * `ToSGate.tsx` already wrote before this module existed — kept verbatim so every browser that has
 * already accepted stays accepted, with zero migration. `toile_tos_accepted` is new; toile has
 * never asked before.
 *
 * Value shape: the string `'true'`, and only that — `'false'` and a parse failure both read as not
 * accepted. Both functions are wrapped in try/catch: absence, a throw (SSR, a private window, site
 * data blocked) or any other value all mean ask. This is byte-for-byte what
 * `products/{narcis,ovid}/components/ToSGate/ToSGate.tsx` wrote before this module existed.
 */

// `HouseId` is the wall's own product-id union (`core/wall/ui/theme.ts`) — 'toile' | 'narcis' |
// 'ovid', the exact three houses this module has a key for. Reused rather than declared a second
// time so the two unions cannot drift apart.
export type {HouseId as ConsentHouse} from '@core/wall/ui/theme'
import type {HouseId} from '@core/wall/ui/theme'

const KEY: Record<HouseId, string> = {
    narcis: 'narcis_tos_accepted',
    ovid: 'ovid_tos_accepted',
    toile: 'toile_tos_accepted',
}

export function readAccepted(house: HouseId): boolean {
    try {
        return localStorage.getItem(KEY[house]) === 'true'
    } catch {
        return false
    }
}

export function writeAccepted(house: HouseId): void {
    try {
        localStorage.setItem(KEY[house], 'true')
    } catch {
        // Private window, site data blocked — the tick still works for this page's life (the
        // reducer's own `status` already moved to 'ticked'/'accepted' regardless of persistence).
    }
}
